// extracted by mini-css-extract-plugin
export default {"startScreen":"StartScreen_startScreen__eqN42","deck":"StartScreen_deck__rbfOv","chooseDeckText":"StartScreen_chooseDeckText__fxdVH","decks":"StartScreen_decks__ls7jJ"};